import { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import { ReactComponent as AddIcon } from "../../assests/icons/add_icon_red.svg";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_PATHS, homeToken } from "../../utils/constant";
import ConnectionHomeCard from "../../components/ConnectionHomeCard";
import {
  ConnectionsHomeContainer,
  ConnectionsHomeAddConnectionBox,
  ConnectionsHomeAddConnectionText,
  ConnectionsHomeBox,
  ConnectionsHomeAddConnectionButton,
  ConnectionsHomeCardsBox,
} from "./ConnectionsHome.styles";
import { useTranslation } from "react-i18next";
import { connectionsApiUrl } from "../../utils/config";
import { useGetRequests } from "../../utils/queries";
import { getSessionFromStorage } from "../../utils/session";
import { useDispatch, useSelector } from "react-redux";
import ConnectionHomeCardSkelton from "../../components/ConnectionHomeCard/ConnectionHomeCard.Skeleton";
import { headerActions } from "../../store/reducers/header";
const ConnectionsHomeSkeleton = () => (
  <>
    <ConnectionsHomeAddConnectionBox>
      <ConnectionsHomeAddConnectionText>
        <Skeleton
          variant="rectangular"
          sx={{ width: "100%", height: "5rem", borderRadius: "0.5rem" }}
        />
      </ConnectionsHomeAddConnectionText>
      <Skeleton
        variant="rectangular"
        sx={{ width: "17.5rem", height: "5rem", borderRadius: "0.5rem" }}
      />
    </ConnectionsHomeAddConnectionBox>
    <ConnectionsHomeCardsBox>
      {[...Array(3)].map((_, i) => {
        return <ConnectionHomeCardSkelton key={i} />;
      })}
    </ConnectionsHomeCardsBox>
  </>
);

const ConnectionsHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const getCount = useGetRequests();
  const { status: authStatus } = useSelector((state) => state.auth.data);
  const [counts, setCounts] = useState({
    myConnections: 0,
    sentRequests: 0,
    receivedRequests: 0,
  });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (authStatus === "success" || getSessionFromStorage()) {
      getCount.mutate(
        {
          url: `${connectionsApiUrl}connection-count`,
        },
        {
          mutationKey: "getCounts",
          onSuccess: (success) => {
            if (success.status === 200) {
              setCounts(success.data.content);
            }
          },
          onError: (error) => {
            console.log(" api call getCount error is ", error);
          },
        }
      );
    }
  }, [authStatus]);

  useEffect(()=>{
    dispatch(headerActions.setIsShrink(false));
  },[]);

  return (
    <ConnectionsHomeContainer>
      <ConnectionsHomeBox>
        {getCount.isSuccess ? (
          <>
            <ConnectionsHomeAddConnectionBox>
              <ConnectionsHomeAddConnectionText>
                {t(homeToken.AddConnectionMessage)}
              </ConnectionsHomeAddConnectionText>
              <ConnectionsHomeAddConnectionButton
                ref={buttonRef}
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => navigate(NAVIGATION_PATHS.AddConnections)}
                onMouseEnter={() => buttonRef.current.focus()}
                onMouseLeave={() => buttonRef.current.blur()}
                disableElevation
                disableRipple
              >
                {t(homeToken.AddConnections)}
              </ConnectionsHomeAddConnectionButton>
            </ConnectionsHomeAddConnectionBox>
            <ConnectionsHomeCardsBox>
              <ConnectionHomeCard
                type={"MyConnections"}
                count={counts.myConnections}
              />
              <ConnectionHomeCard
                type={"SentRequests"}
                count={counts.sentRequests}
              />
              <ConnectionHomeCard
                type={"ReceivedRequests"}
                count={counts.receivedRequests}
              />
            </ConnectionsHomeCardsBox>
          </>
        ) : getCount.isError ? (
          <h1 style={{ color: "#64666A" }}>{t(homeToken.GenericError)}</h1>
        ) : (
          <ConnectionsHomeSkeleton />
        )}
      </ConnectionsHomeBox>
    </ConnectionsHomeContainer>
  );
};

export default ConnectionsHome;
